// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9ff7f75","455":"72343dcf","977":"6f1e51bd"}[chunkId] + ".chunk.js";
};